<template>
  <section class="pmp-success-screen">
    <div class="pmp-success-card pmp-success-card--compact">
      <div class="pmp-success-icon">
        <i class="bi bi-check2-circle" aria-hidden="true"></i>
      </div>

      <h1 class="pmp-success-title">Reporte enviado</h1>

      <p class="pmp-success-text">
        El consumo fue registrado correctamente en el sistema.
      </p>

      <div class="pmp-receipt pmp-receipt--compact">
        <div class="pmp-receipt-row">
          <span>Folio</span>
          <strong class="pmp-receipt-folio">
            {{ form.folio || 'CMP-0000' }}
          </strong>
        </div>

        <div class="pmp-receipt-row">
          <span>Operador</span>
          <strong>{{ form.operadorLabel || '—' }}</strong>
        </div>

        <div class="pmp-receipt-date">
          {{ fechaHoraLabel }}
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  form: {
    type: Object,
    required: true
  }
})

const fechaHoraLabel = computed(() => {
  if (!props.form.fecha && !props.form.hora) return 'Fecha no registrada'

  const fecha = props.form.fecha
    ? formatDate(props.form.fecha)
    : 'Fecha no registrada'

  const hora = props.form.hora || '--:--'

  return `${fecha}, ${hora}`
})

function formatDate(value) {
  if (!value) return 'Fecha no registrada'

  const date = new Date(`${value}T00:00:00`)

  return date.toLocaleDateString('es-MX', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  })
}
</script>